import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';
import { NewReportOptionsTemplateDirective } from '../../../shared/directives/new-report-options-template.directive';
import { ReportClientOptionComponent } from '../../../shared/components/report-client-option/report-client-option.component';
import { ReportDateRangeOptionComponent } from '../../../shared/components/report-date-range-option/report-date-range-option.component';
import { ReportBooleanOptionComponent } from '../../../shared/components/report-boolean-option/report-boolean-option.component';
import { ReportDetailsTemplateDirective } from '../../../shared/directives/report-details-template.directive';
import { ReportAppliedClientOptionComponent } from '../../../shared/components/report-applied-client-option/report-applied-client-option.component';
import { ReportAppliedDateRangeOptionComponent } from '../../../shared/components/report-applied-date-range-option/report-applied-date-range-option.component';
import { ReportAppliedBooleanOptionComponent } from '../../../shared/components/report-applied-boolean-option/report-applied-boolean-option.component';

@Component({
    templateUrl: './capture-admin-capture-billing-state-reports.component.html',
    imports: [ReportsComponent,
              NewReportOptionsTemplateDirective,
              FormsModule,
              ReactiveFormsModule,
              ReportClientOptionComponent,
              ReportDateRangeOptionComponent,
              ReportBooleanOptionComponent,
              ReportDetailsTemplateDirective,
              ReportAppliedClientOptionComponent,
              ReportAppliedDateRangeOptionComponent,
              ReportAppliedBooleanOptionComponent]
})
export class CaptureAdminCaptureBillingStateReportsComponent {
  private formBuilder = inject(UntypedFormBuilder);

  reportsUrl = `${environment.captureApi.url}/capture_billing_state_reports`;
  reportsCountUrl = `${environment.captureApi.url}/capture_billing_state_reports/count`;

  filtersForm = this.formBuilder.group({
    clientIds: [null],
    mostRecentStateChange: [null],
    originalBillingDate: [null],
    requiresInvoiceOrCredit: [null],
  });
}
